import { AsyncPipe, DatePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core'
import { MeetingsService } from '../../meetings.service'
import { DATE_TIME_FORMAT, resolveLocalTimeZone } from '../../utils'
import { SpinnerComponent } from '../../spinner/spinner.component'

export type RetentionExtensionHistoryDialogData = {
  meetingId: number
  meetingName: string
}

@Component({
  selector: 'app-retention-extension-history-dialog',
  standalone: true,
  imports: [
    AsyncPipe,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatButton,
    TranslatePipe,
    TranslateDirective,
    DatePipe,
    SpinnerComponent,
  ],
  templateUrl: './retention-extension-history-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './retention-extension-history-dialog.component.scss',
})
export class RetentionExtensionHistoryDialogComponent {
  data: RetentionExtensionHistoryDialogData = inject<RetentionExtensionHistoryDialogData>(MAT_DIALOG_DATA)
  meetingsService = inject(MeetingsService)

  // Read in the same zone the extension was picked in, so the trail agrees with the dialog that
  // wrote it rather than shifting the dates an hour or two on the way back.
  localTimeZone = resolveLocalTimeZone()
  dateTimeFormat = DATE_TIME_FORMAT

  extensions$ = this.meetingsService.getRetentionExtensions(this.data.meetingId)
}
